import React, { PureComponent } from "react";
import styled, { keyframes } from "styled-components";

import buildColor from "../ColorPalette";

const pulseAnimation = keyframes`
  0% {
    fill: ${buildColor("blue", "000")};
  }
  
  50% {
    fill: ${buildColor("blue", "100")};
  }
  
  100% {
    fill: ${buildColor("blue", "000")};
  }
`;

const SVG = styled.svg`
  display: block;
  width: 100%;
  height: 698px;

  rect.pulse {
    animation: ${pulseAnimation} 1.25s infinite;
  }
`;

export default class RegistrationBodyMask extends PureComponent {
  render() {
    return (
      <div data-qa-label="registrationBodyMask">
        <SVG>
          <g>
            <rect className="pulse" y="671" width="197" height="17" rx="2" />
            <rect className="pulse" y="615" width="440" height="44" rx="2" />
            <rect className="pulse" width="96" height="17" rx="2" />
            <rect className="pulse" x="344" width="96" height="17" rx="2" />
            <rect className="pulse" y="25" width="440" height="42" rx="2" />
            <rect className="pulse" y="86" width="172" height="17" rx="2" />
            <rect className="pulse" y="111" width="440" height="42" rx="2" />
            <rect className="pulse" y="171" width="122" height="17" rx="2" />
            <rect className="pulse" y="196" width="440" height="42" rx="2" />
            <rect className="pulse" y="256" width="122" height="17" rx="2" />
            <rect className="pulse" y="281" width="440" height="42" rx="2" />
            <rect className="pulse" y="341" width="122" height="17" rx="2" />
            <rect className="pulse" y="366" width="440" height="42" rx="2" />
            <rect className="pulse" y="504" width="164" height="17" rx="2" />
            <rect className="pulse" y="529" width="204" height="17" rx="2" />
            <rect className="pulse" y="554" width="172" height="17" rx="2" />
            <rect className="pulse" y="579" width="197" height="17" rx="2" />
            <rect className="pulse" y="426" width="122" height="17" rx="2" />
            <rect className="pulse" y="451" width="440" height="42" rx="2" />
          </g>
        </SVG>
      </div>
    );
  }
}
